import { createContext } from 'react'

const FadeInSectionContext = createContext(false)

export { FadeInSectionContext }
